import React from 'react'
import { IKImage } from 'imagekitio-react'

/**
 * IKImageWrapper - Environment-aware image component
 *
 * Automatically handles:
 * - Local development: Uses 'src' prop for full URLs from MinIO proxy
 * - Production: Uses 'path' prop for S3 keys with ImageKit CDN
 */
export default function IKImageWrapper({ image, transformation, loading, lqip, alt, className, style }) {
	if (!image) {
		return null
	}

	// Check if image is a full URL (local development)
	const isFullUrl = image.startsWith('http://') || image.startsWith('https://')

	if (isFullUrl) {
		// Local development: Full URL from MinIO proxy
		return (
			<IKImage
				src={image}
				transformation={transformation}
				loading={loading}
				lqip={lqip}
				alt={alt}
				className={className}
				style={style}
			/>
		)
	}

	// Production: S3 key for ImageKit CDN
	return (
		<IKImage
			path={image}
			transformation={transformation}
			loading={loading}
			lqip={lqip}
			alt={alt}
			className={className}
			style={style}
		/>
	)
}
